import { Component, Input, SimpleChanges } from '@angular/core';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { Observable, Subscription, interval } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-supervis-diary-cpc',
  templateUrl: './supervis-diary-cpc.component.html',
  styleUrls: ['./supervis-diary-cpc.component.css']
})
export class SupervisDiaryCpcComponent {

  @Input() receivedDate: string | null = null;
  @Input() receiveSupcode: string | null = null;

  brddata?: any | null = [];
  dateLabel: string | null = null;
  selectedDate: string | null = null;
  private subscription: Subscription;
  selectedData: string | null = null;

  constructor(
    private brdservice: BrdsqlService,
    private spinner: NgxSpinnerService
  ) {

  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['receiveSupcode'] && this.receiveSupcode.trim()) {
      const date: string = this.receivedDate;
      const supcode: string = this.receiveSupcode;
      this.getDateToday(date);
      this.getSupervisDiaryCPC(date ,supcode);
    }
  }

  getDateToday(date: string) {
    const today = new Date(date);
    const thaiDate = today.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    });
    this.dateLabel = thaiDate;
  }

  async getSupervisDiaryCPC(date: string, supcode: string) {
    this.spinner.show()
    this.subscription = await this.brdservice.getSupervisCPCDiaryReport(date, supcode)
      .subscribe({
        next: (res) => {
          // console.log('res :', res);
          if (res.recordset) {
            this.brddata = res.recordset[0]
            console.log('supervis data :', this.brddata);
          }
        }, error(err) {
          console.log('err:', err)
        }, complete: () => {
          // console.log('complete');
          this.spinner.hide();
        },
      })
  }

  ngOnDestroy(): void {
    // Unsubscribe เมื่อ Component ถูกทำลาย
    if (this.subscription) {
      this.subscription.unsubscribe();
      console.log('Unsubscribed!');
    }
  }

  date2en(date: Date): string {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  // onSelectChange(event: MatSelectChange): void {
  //   this.selectedData = event.value;
  //   console.log('คุณเลือก:', this.selectedData);
  // }

  // onSupcodeInput() {
  //   if(this.supcode!== '' || this.supcode == null) {
  //     this.showCalendar = true;
  //   } else {
  //     this.showCalendar = false;
  //   }
  //   console.log('supcode :' ,this.supcode);
  // }  

  // onDateChange(e) {
  //   let date = e.target.value
  //   date = this.date2en(date)
  //   // console.log('target1', date);
  //   // console.log('target2', this.date2en(date));
  //   this.getDateToday(date);
  //   this.getSupervisDiaryCPC(date ,this.supcode);
  // }  

  // ngOnChanges() {
  //   console.log('date supcode :' ,this.receivedDate ,this.receiveSupcode)
  //   this.getDateToday(this.receivedDate);
  //   // this.getSupervisDiaryCPC(this.receivedDate ,this.receiveSupcode);
  // }


}
